module.exports = __webpack_public_path__ + "static/media/screenshot-drawing-app.68412fec.png";